/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Eleven_FramesInputs */

const en_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const fr_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const de_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const it_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const ru_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const es_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const zh_cn2_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const ja_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const hi_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

const pt_pt2_shortcut_keys_name_reverse_eleven_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 11 Frame`)
};

/**
* | output |
* | --- |
* | "Reverse 11 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_Eleven_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_eleven_frames = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Eleven_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "de") return de_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "it") return it_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "es") return es_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_reverse_eleven_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_reverse_eleven_frames(inputs)
	return en_shortcut_keys_name_reverse_eleven_frames(inputs)
});